var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("vue-custom-scrollbar", [
        _c(
          "div",
          {
            staticClass:
              "ap-workspace-table-container workspace-admin-scroll-part"
          },
          [
            _c("table", { staticClass: "result-table" }, [
              _c("thead", [
                _c("tr", { staticClass: "head-tr" }, [
                  _c("th", [_vm._v("№")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Название переменной")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Значение")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Значение по умолчанию")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "field-edit" }, [_vm._v("Опции")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.config, function(value, index) {
                  return _c("tr", { staticClass: "body-tr row" }, [
                    _c("td", [
                      _c("span", { staticClass: "table-data" }, [
                        _vm._v(_vm._s(index + 1))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "table-data" }, [
                        _vm._v(_vm._s(value.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "table-data" }, [
                        _vm._v(_vm._s(value.value))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "table-data" }, [
                        _vm._v(_vm._s(value.default))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", { staticClass: "edit-button-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "table-svg-button",
                            on: {
                              click: function($event) {
                                return _vm.editRow(value)
                              }
                            }
                          },
                          [_c("SVGAdminEditRow")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "table-svg-button",
                            on: {
                              click: function($event) {
                                return _vm.confirm(value)
                              }
                            }
                          },
                          [_c("SVGPhotoRotateLeft")],
                          1
                        )
                      ])
                    ])
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _vm.waitingResponseToConfigRequest
              ? _c(
                  "div",
                  { staticClass: "ap-loader-grid" },
                  [
                    _c("SpinnerTwo"),
                    _vm._v(" "),
                    _c("div", { staticClass: "ap-loader-text" }, [
                      _vm._v(
                        "\n                        Идет загрузка переменных ...\n                    "
                      )
                    ])
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ap-workspace-head" }, [
      _c("div", { staticClass: "ap-workspace-label" }, [
        _c("div", { staticClass: "ap-workspace-label-name" }, [
          _vm._v(
            "\n                    Конфигурация приложения\n                "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }